export default __webpack_public_path__ + "becc0f0d7355135495ba6caa7b3e6aea.webp";